<template>
  <thead class="thead-light">
  <tr>
    <th v-for="(column, index) in columnConfig" :key="index"
        :class="{'text-center': column.columnCode === 'actions'}">
      <Render v-if="column.columnCode === 'action'" :data="column" :render="column.icon"/>
      <span v-else>{{ column.columnName }}</span>
    </th>
  </tr>
  </thead>
</template>

<script>
export default {
  name: 'CustomTableHeader',
  props: {
    columnConfig: {
      type: Array,
      required: true
    },
    sortField: {
      type: String,
      required: true
    },
    order: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      pageSelected: false
    }
  },
  methods: {
    toggleSort (columnCode) {
      this.$emit('sort-update', columnCode)
    }
  }
}
</script>

<style lang="scss" scoped>

  th.vue-table-header {
    white-space: nowrap;
    align-content: center;

    .is-clickable {
      cursor: pointer;
    }

    .table-header-controls {
      .sorter {
        cursor: pointer;
        opacity: 0.5;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
  .action-column {
    width: 50px;
  }
</style>
